module.exports = __webpack_public_path__ + "static/media/botanicalSequoia.2614c485.jpg";